import { render, staticRenderFns } from "./BaseSelectList.vue?vue&type=template&id=9c4ddcf8&scoped=true&"
import script from "./BaseSelectList.vue?vue&type=script&lang=js&"
export * from "./BaseSelectList.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectList.vue?vue&type=style&index=0&id=9c4ddcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4ddcf8",
  null
  
)

export default component.exports